import { useState } from "react";
import { useDispatch } from "react-redux";
import useMerchantPortalAxios from "../../utils/axios";
import { setAllCurrencies } from "../../features/statementOfAccountSlice";

export default function useNewCommonAPI() {
  const client = useMerchantPortalAxios();
  const dispatch = useDispatch();

  const [regions, setRegions] = useState([]);
  const [tillTypes, setTillTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [roles, setRoles] = useState(null);
  const [userName, setUserName] = useState(null);

  async function getAllRegions() {
    const res = await client.get("/v1/CommonData/GetAllRegions");
    setRegions(res?.data?.Regions || []);
    return res?.data;
  }

  async function getAllTillTypes() {
    const res = await client.get("/v1/CommonData/GetAllTillTypes");
    setTillTypes(res?.data?.TillTypes || []);
    return res?.data;
  }

  async function getAllCurrencies() {
    const res = await client.get("/v1/CommonData/GetAllCurrencies");
    const nextCurrencies = res?.data?.Currencies || [];

    setCurrencies(nextCurrencies);
    dispatch(setAllCurrencies(nextCurrencies));
    sessionStorage.setItem("Currencies", JSON.stringify(nextCurrencies));

    return nextCurrencies;
  }

  async function getAllEmployeesRoles() {
    const res = await client.get("/v1/CommonData/GetAllEmployeesRoles");
    setRoles(res?.data?.AllRoles || null);
    return res?.data;
  }

  async function GetUserNameByMobileNo(mobileNo, typeId = 2) {
    const res = await client.post("/v1/CommonData/GetUserNameByMobileNo", {
      SessionID: sessionStorage.getItem("SessionID"),
      MobileNo: mobileNo,
      AccountTypeId: typeId,
    });

    setUserName(res?.data?.Payload?.Name || null);
    return res?.data;
  }

  async function GetMobileNoByAccountName(name, accountType) {
    const res = await client.post("/v1/CommonData/GetMobileNoByAccountName", {
      SessionID: sessionStorage.getItem("SessionID"),
      Name: name,
      AccountTypeId: accountType,
    });

    return res?.data;
  }

  return {
    getAllRegions,
    getAllTillTypes,
    getAllCurrencies,
    getAllEmployeesRoles,
    GetUserNameByMobileNo,
    GetMobileNoByAccountName,
    regions,
    tillTypes,
    currencies,
    roles,
    userName,
    setUserName,
  };
}
